export default "__VITE_ASSET__33fc5b7a__"